import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { CreateJobFormAction } from '../../../Redux/action/CreateJobFormAction';
import { EditJobFormAction } from '../../../Redux/action/EditJobAction';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { JobsDetails } from '../../../Redux/action/VendorJobDetailsAction';
import { fetchDepartmentDetails, fetchDesignationDetails, fetchSkillDetails } from '../../../Redux/action/MasterSkillAction';
import { useCountries } from '../../../Hooks/useCountries';
import { useStatesByCountry } from '../../../Hooks/useStatesByCountry';
import { Button, Form, Modal } from 'react-bootstrap';
import { postLaterApi } from '../../../Services/JobServices';
import BackButton from '../../Common/BackButton/BackButton';

const RepostJob = () => {
    const AllSkillList = useSelector((state) => state?.MasterTableDetails?.skill?.content)
    const [startDate, setDate] = useState(new Date())
    const [jobLocations, setJobLocations] = useState([]);
    const [daysn, setDaysn] = useState([]);
    const [file, setFile] = useState(null);
    const [postLateerModal, setpostLateerModal] = useState(false);
    const [isPostlater, setIsPostlater] = useState(false);
    const [disabled, setDisabled] = useState(false)
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [selectedWork, setSelectedWork] = useState([])
    const [date, setDatePl] = useState('');
    const [time, setTime] = useState('');
    const { id } = useParams();
    const dispatch = useDispatch();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const location = useLocation();
    const { pathname } = useLocation();
    const userInfo = useSelector((state) => state.VendorJobDetails.result);
    const AllDesignationList = useSelector((state) => state?.MasterTableDetails?.designation?.content);
    useEffect(() => {
        dispatch(fetchSkillDetails())
        dispatch(JobsDetails(id));
        dispatch(fetchDesignationDetails())
    }, []);

    const [selectedLocations, setSelectedLocations] = useState([]);

    const [data, setData] = useState({
        vendorId: "",
        jobTitle: "",
        minimumExperience: "",
        maximumExperience: "",
        requiredSkills: [],
        jobDescription: "",
        workType: "",
        jobType: "",
        shiftTime: "",
        flexibleHours: "",
        validity: "",
        workingWeekDays: [],
        openingTime: "",
        closingTime: "",
        file: null,
        jobsPostedStatus: "",
        workingDays: "",
        country: "",
        state: "",
    });

    const WeekOptions = [
        { value: "MONDAY", label: "MONDAY" },
        { value: "TUESDAY", label: "TUESDAY" },
        { value: "WEDNESDAY", label: "WEDNESDAY" },
        { value: "THURSDAY", label: "THURSDAY" },
        { value: "FRIDAY", label: "FRIDAY" },
        { value: "SATURDAY", label: "SATURDAY" },
        { value: "SUNDAY", label: "SUNDAY" }
    ]
    const inDraft = new URLSearchParams(location.search).get("inDraft");
    useEffect(() => {
        if (userInfo) {
            setData({
                jobId: userInfo.jobId || 0,
                vendorId: userInfo.vendorId || 0,
                jobTitle: userInfo.jobTitle || "",
                jobDescription: userInfo.jobDescription || "",
                shiftTime: userInfo.shiftTime || "",
                flexibleHours: userInfo.flexibleHours || "",
                workType: userInfo.workType,
                openingTime: userInfo.startTime || "",
                closingTime: userInfo.endTime || "",
                jobLocation: userInfo.jobLocation || "",
                minimumExperience: userInfo.minimumExperience || "",
                maximumExperience: userInfo.maximumExperience || "",
                requiredSkills: userInfo.requiredSkills || [],
                jobsPostedStatus: userInfo.jobsPostedStatus,
                workingWeekDays: userInfo.workingWeekDays || [],
                jobType: userInfo.employmentType,
                validity: userInfo.validity || '',
                workingDays: userInfo.workingDays,
                country: userInfo.country,
                state: userInfo.state,
            });
            const selectedSkills = userInfo?.requiredSkills?.map(skill => ({ value: skill, label: skill }));
            setSelectedSkills(selectedSkills);
            const selectedWeeks = userInfo?.workingWeekDays?.map(skill => ({ value: skill, label: skill }));
            setSelectedWork(selectedWeeks);
            const selectedLocations = userInfo.jobLocation ? userInfo.jobLocation.split(',').map(location => ({ value: location, label: location })) : [];
            setSelectedLocations(selectedLocations);
        }
    }, [userInfo]);

    const { jobId, jobsPostedStatus, openingTime, closingTime, minimumExperience, maximumExperience, jobTitle, country, state, validity, requiredSkills, workType, jobDescription, shiftTime, jobType, workingDays, flexibleHours, workingWeekDays } = data;
    const { data: countriesData, isLoading: countriesLoading } = useCountries();
    const { data: stateList, isLoading, isError } = useStatesByCountry(data?.country || "India");
    const minimumExperiences = minimumExperience;

    let listMin = Array.from({ length: 31 }, (_, i) => i + " years");
    let list = Array.from({ length: 30 }, (_, i) => (i + 1) + " years");

    let ListData = [];
    list.map((ndata) => {
        if (minimumExperiences < ndata) {
            ListData.push(ndata)
        }
    })

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        if (name === "requiredSkills") {
            value = value.split(",").map((requiredSkills) => requiredSkills.trim());
        }
        setData({ ...data, [name]: value });
    };
    const defaultEndDate = new Date()
    defaultEndDate.setDate(defaultEndDate.getDate() + 7)
    const { userResult } = useSelector((state) => state.Auth);
    let vendorId = userResult?.vendorid;

    const days = daysn.toString()
    const navigate = useNavigate();

    const handleTimeInputChange = (e) => {
        let { name, value } = e.target;
        setData({ ...data, [name]: value });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        const [openingHour, openingMinute] = openingTime.split(':').map(Number);
        const [closingHour, closingMinute] = closingTime.split(':').map(Number);
        if (jobType != "FULL_TIME") {
            if (!openingTime || !closingTime) return toast.error("start time and end time is required")
        }
        if (shiftTime === 'sameDay') {
            // Same Day: closingTime must be after openingTime
            const closingTimeData = Number(closingTime.split(":")[0]) + Number(closingTime.split(":")[1] / 60);
            const openingTimeData = Number(openingTime.split(":")[0]) + Number(openingTime.split(":")[1] / 60);
            if ((closingTimeData - openingTimeData) < 0.5) {
                toast.error('For same-day shifts, closing time must be min 30 min after opening time.');
                return;
            }
        } else if (shiftTime === 'overnight') {
            if (
                closingHour > openingHour ||
                (closingHour === openingHour && closingMinute > openingMinute)
            ) {
                toast.error('For overnight shifts, closing time must be on the next day (e.g., 23:00 → 07:00).');
                return;
            }
        }
        const formData = new FormData();
        if (parseInt(workingDays) != workingWeekDays.length) {
            toast.error("Working days and working week days must match.");
            return;
        }
        if (parseInt(maximumExperience) <= parseInt(minimumExperience)) {
            // Show toast notification
            toast.error("Maximum experience should be greater than minimum experience");
            return;
        }

        if (isPostlater) {
            setpostLateerModal(true);
            return;
        }
        setDisabled(true);
        let jobsData
        if (pathname.split("/")[1] === "edit_job" || location.pathname.includes("edit_Validity_job")) {
            jobsData = {
                jobId,
                minimumExperience,
                maximumExperience,
                jobTitle,
                validity,
                requiredSkills,
                workType,
                jobDescription,
                startTime: openingTime,
                endTime: closingTime,
                jobLocation: jobLocations.map(skill => skill.value).join(', '),
                days,
                shiftTime,
                workingWeekDays,
                jobType,
                flexibleHours,
                jobsPostedStatus,
                workingDays,
                country,
                state,
            };
        } else {
            jobsData = {
                vendorId,
                minimumExperience,
                maximumExperience,
                jobTitle,
                validity,
                requiredSkills,
                workType,
                jobDescription,
                startTime: openingTime,
                endTime: closingTime,
                jobLocation: jobLocations.map(skill => skill.value).join(', '),
                days,
                shiftTime,
                workingWeekDays,
                jobType,
                flexibleHours,
                jobsPostedStatus: "POSTED",
                workingDays,
                country,
                state,
            };
        }
        formData.append('jobs', JSON.stringify(jobsData));
        formData.append('file', file);
        if (pathname.split("/")[1] === "edit_job" || pathname.includes("edit_Validity_job")) {
            dispatch(
                EditJobFormAction(formData, navigate)
            );
        } else {
            dispatch(
                CreateJobFormAction(formData, navigate)
            );
        }
    };

    const submitPostLater = () => {
        if (!date) return toast.error("Date is required");
        if (!time) return toast.error("Time is required");
        const formData = new FormData();
        const jobsData = {
            vendorId,
            minimumExperience,
            maximumExperience,
            jobTitle,
            validity,
            requiredSkills,
            workType,
            jobDescription,
            startTime: openingTime,
            endTime: closingTime,
            jobLocation: jobLocations.map(skill => skill.value).join(', '),
            days,
            workingWeekDays,
            shiftTime,
            employmentType: jobType,
            workingDays,
            flexibleHours,
            jobsPostedStatus: "POSTLATER",
            postLaterDate: date,
            postLaterTime: time,
            zoneId: timeZone,
        };
        formData.append('jobs', JSON.stringify(jobsData));
        formData.append('file', file);
        postLaterApi(formData).then((res) => {
            if (res?.data) {
                setTimeout(() => {
                    setDisabled(false)
                    navigate("/posted_jobs?active=post-later")
                }, 1000);
            }
        }).catch((error) => {
        })
    }

    const options = AllSkillList?.map((item) => (
        {
            'value': item?.skillName,
            'label': item?.skillName
        }
    ))
    const handleSkillsChange = (selectedOptions) => {
        setSelectedSkills(selectedOptions)
        const selectedValues = selectedOptions.map(option => option.value);
        setData({ ...data, requiredSkills: selectedValues });
    };

    const handleLocationChange = (selectedOptions) => {
        setSelectedLocations(selectedOptions);
        setJobLocations(selectedOptions)
    };


    const formatDate = (dateString) => {
        const [year, month, day] = dateString ? dateString.split('-') : [];
        return `${day}-${month}-${year}`;
    };

    const DateFormat = (dateString) => {
        const [day, month, year] = dateString ? dateString.split('-') : [];
        return `${year}-${month}-${day}`
    }

    const handleDateChange = (inputValue) => {
        const [day, month, year] = inputValue.split('-');
        const formattedDate = `${year}-${month}-${day}`;
        setData({ ...data, validity: formattedDate });
    };
    const arr = [1, 2, 3, 4, 5]
    const handleSkillsChange1 = (selectOption) => {
        setSelectedWork(selectOption)
        const selectValue = selectOption?.map((item) => item.value);
        setData((data) => ({
            ...data,
            workingWeekDays: selectValue
        }))
    }
    useEffect(() => {
        if (workType === "REMOTE") {
            setData({ ...data, state: "", country: "" })
        }
    }, [workType]);

    const handleClose = () => { setpostLateerModal(false); setIsPostlater(false); setDatePl(); setTime() }

    const formatDateForInput = (str) => {
        const [day, month, year] = str?.split("-");
        return `${year}-${month}-${day}`;
    };

    const getTomorrowDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow?.getDate() + 1);
        return tomorrow?.toISOString()?.split("T")[0];
    };
    const minDate = getTomorrowDate();
    const maxDate = formatDateForInput(validity);

    return (
        <div className='d-flex flex-column flex-md-row gap-4 container'>
            <ToastContainer />
            <div className='can_prof_container'>
                {/* <BackButton/> */}
                <div>
                    <div className="row d-flex justify-content-center align-items-center">
                        <div >
                            <div className="card can_prof_main">
                                <div className="card-header prof_header d-flex justify-content-between"> {pathname?.includes('post_job') ? 'Post Job' : (pathname.split("/")[1] === "edit_Validity_job" ? "Edit Job" : "Repost Job")}
                                    {/* <span>
                                        {isDisabled ? <CiEdit onClick={handleEdit} className='pointer' /> : <RiForbid2Line color='red' onClick={handleEdit} className='pointer' />}
                                    </span> */}
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row gx-3 mb-3">
                                            <div className="col-12 col-md-6 col-sm-12">
                                                <label className="small mb-1" htmlFor="inputWorkType">
                                                    Work Type
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="inputWorkType"
                                                    name="workType"
                                                    value={workType}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={pathname.includes("/edit_Validity_job")}
                                                >
                                                    <option value="">Select Work Type</option>
                                                    <option value="REMOTE">Remote</option>
                                                    <option value="ONSITE">OnSite</option>
                                                    <option value="HYBRID">hybrid</option>
                                                </select>
                                            </div>
                                            <div className="col-12 col-md-6 col-sm-12">
                                                <label className="small mb-1" htmlFor="inputInterest">
                                                    Designation
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                {/* <input
                                                    className="form-control"
                                                    id="inputInterest"
                                                    type="text"
                                                    name='jobTitle'
                                                    placeholder="Enter job Title"
                                                    value={jobTitle}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={pathname.includes("/edit_Validity_job")}
                                                /> */}
                                                <select id="inputInterest" value={jobTitle} disabled={pathname.includes("/edit_Validity_job")}
                                                    name="jobTitle" onChange={handleInputChange} className='form-select'>
                                                    <option value="" disabled hidden>
                                                        Select any job title
                                                    </option>
                                                    {AllDesignationList?.map((option) => (
                                                        <option key={option?.designationId} value={option?.designation}>
                                                            {option.designation}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row gx-3 mb-3">
                                            <div className="col-md-3">
                                                <label className="small mb-1" htmlFor="inputJobLocations">
                                                    Country
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="country"
                                                    name="country"
                                                    value={country}
                                                    onChange={(e) => setData({ ...data, country: e.target.value, state: '' })}
                                                    required
                                                    disabled={workType === "REMOTE" || pathname.includes("/edit_Validity_job")}
                                                >
                                                    <option value="" disabled>select country</option>
                                                    {countriesData?.data?.map((option) => (
                                                        <option key={option?.country} value={option?.country}>  {option?.country}</option>))}

                                                </select>
                                                {/* <Select
                                                    options={placeOptions}
                                                    isMulti
                                                    onChange={handleLocationChange}
                                                    value={selectedLocations}
                                                    isDisabled={(workType === "REMOTE") || (pathname.includes("/edit_Validity_job"))}
                                                    required={true}

                                                /> */}
                                            </div>
                                            <div className="col-md-3">
                                                <label className="small mb-1" htmlFor="inputJobLocations">
                                                    State
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="state"
                                                    name="state"
                                                    value={state}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={workType === "REMOTE" || pathname.includes("/edit_Validity_job")}
                                                >
                                                    <option value="" disabled>select state</option>
                                                    {stateList && stateList?.data?.states?.map((option) => (
                                                        <option key={option?.name} value={option?.name}> {option?.name} </option>))}

                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="small mb-1" htmlFor="inputMinExp">
                                                    Min Exp
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="inputMinExp"
                                                    name="minimumExperience"
                                                    value={minimumExperience}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={pathname.includes("/edit_Validity_job")}
                                                >
                                                    <option value="">Select Min Exp</option>
                                                    {
                                                        listMin.map((item, i) => (
                                                            <option key={i} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="small mb-1" htmlFor="inputMinExp">
                                                    Max Exp
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="inputMinExp"
                                                    name="maximumExperience"
                                                    value={maximumExperience}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={pathname.includes("/edit_Validity_job")}
                                                >
                                                    <option value="">Select Max Exp</option>
                                                    {
                                                        list.map((item, i) => (
                                                            <option key={i} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>

                                        </div>
                                        <div className="row gx-3 mb-3">
                                            <div className="col-md-6">
                                                <label className="small mb-1" htmlFor="inputInterest">
                                                    Job Expiry Date
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <input
                                                    className="form-control"
                                                    id="inputInterest"
                                                    type="date"
                                                    // placeholder="Enter validity"
                                                    name='validity'
                                                    value={formatDate(validity)}
                                                    onChange={(e) => handleDateChange(e.target.value)}
                                                    placeholder="Enter Validity"
                                                    min={minDate}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="small mb-1" htmlFor="inputInterest">
                                                    Job Type
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>

                                                <select
                                                    className="form-select"
                                                    id="inputWorkType"
                                                    name="jobType"
                                                    value={jobType}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={pathname.includes("/edit_Validity_job")}
                                                >
                                                    <option value="" disabled>Select Work Type</option>
                                                    <option value="FULL_TIME">Full Time</option>
                                                    <option value="PART_TIME">Part Time</option>
                                                    <option value="FLEXIBLE">Flexible Time</option>
                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="small mb-1" htmlFor="inputInterest">
                                                    Working Days
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>

                                                <select
                                                    className="form-select"
                                                    id="inputWorkType"
                                                    name="workingDays"
                                                    value={workingDays}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={pathname.includes("/edit_Validity_job")}
                                                >
                                                    <option value="" disabled>Select number of days</option>
                                                    <option value={1}>1</option>
                                                    <option value={2}>2</option>
                                                    <option value={3}>3</option>
                                                    <option value={4}>4</option>
                                                    <option value={5}>5</option>
                                                    <option value={6}>6</option>

                                                </select>
                                            </div>
                                        </div>
                                        {(jobType === "PART_TIME" || jobType === "FLEXIBLE") &&
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-4">
                                                    <label className="small mb-1" htmlFor="inputInterest">
                                                        Shift Type
                                                        <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                    </label>
                                                    <select
                                                        className="form-select"
                                                        id="shiftTime"
                                                        name="shiftTime"
                                                        value={shiftTime}
                                                        onChange={handleInputChange}
                                                        required
                                                        disabled={pathname.includes("/edit_Validity_job")}
                                                    >
                                                        <option value="" disabled>Select shift type</option>
                                                        <option value="sameDay">Same Day (e.g., 09:00 – 17:00)</option>
                                                        <option value="overnight">Overnight (e.g., 23:00 – 07:00)</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="small mb-1" htmlFor="inputInterest">
                                                        Start Time
                                                        <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputInterest"
                                                        type="time"
                                                        name='openingTime'
                                                        placeholder="Enter opening time"
                                                        value={openingTime}
                                                        // onChange={handleInputChange}
                                                        onChange={handleTimeInputChange}
                                                        disabled={pathname.includes("/edit_Validity_job")}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="small mb-1" htmlFor="inputInterest">
                                                        End Time
                                                        <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputInterest"
                                                        type="time"
                                                        name='closingTime'
                                                        placeholder="Enter closing time"
                                                        value={closingTime}
                                                        // onChange={handleInputChange}
                                                        onChange={handleTimeInputChange}
                                                        disabled={pathname.includes("/edit_Validity_job")}
                                                    />
                                                </div>
                                            </div>}
                                        <div className="row gx-3 mb-3">
                                            <div className="col-md-12">
                                                <label className="small mb-1" htmlFor="inputWorkDays">
                                                    Working Week Days<span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <Select
                                                    autoFocus={false}
                                                    options={WeekOptions}
                                                    isClearable={false}
                                                    isMulti
                                                    isDisabled={pathname.includes("/edit_Validity_job")}
                                                    onChange={handleSkillsChange1}
                                                    value={selectedWork}
                                                    styles={{
                                                        multiValue: (styles, { data }) => ({
                                                            ...styles,
                                                            backgroundColor: "#286a94",
                                                        }),
                                                        multiValueLabel: (styles, { data }) => ({
                                                            ...styles,
                                                            color: "white",
                                                        }),
                                                        multiValueRemove: (styles, { data }) => ({
                                                            ...styles,
                                                            color: "white",
                                                            ":hover": {
                                                                backgroundColor: "#1a4b6d",
                                                                color: "white",
                                                            },
                                                        }),
                                                    }}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="row gx-3 mb-3">
                                            <div className="col-md-12 ">
                                                <label className="small mb-1" htmlFor="inputOrgName">
                                                    Skills
                                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                </label>
                                                <Select options={options} isMulti onChange={handleSkillsChange} value={selectedSkills} required={true}
                                                    isDisabled={pathname.includes("/edit_Validity_job")}
                                                    styles={{
                                                        multiValue: (styles, { data }) => ({
                                                            ...styles,
                                                            backgroundColor: '#286a94',
                                                        }),
                                                        multiValueLabel: (styles, { data }) => ({
                                                            ...styles,
                                                            color: 'white',
                                                        }),
                                                        multiValueRemove: (styles, { data }) => ({
                                                            ...styles,
                                                            color: 'white',
                                                            ':hover': {
                                                                backgroundColor: '#1a4b6d',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }} />
                                            </div>
                                        </div>


                                        <div className="col-md-12 mt-3">
                                            <label className="small mb-1" htmlFor="inputOrgName">
                                                Description
                                                <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="inputOrgName"
                                                // cols={10}
                                                rows={7}
                                                type="text"
                                                name='jobDescription'
                                                placeholder="Enter Job Description"
                                                value={jobDescription}
                                                onChange={handleInputChange}
                                                maxLength={500}
                                                required
                                                disabled={pathname.includes("/edit_Validity_job")}
                                            // disabled={isDisabled}
                                            />
                                        </div>

                                        <div className="row gx-3 mt-3 mb-3">
                                            <div className="col-12 col-md-12 col-lg-12">

                                                <label className="small mb-1" htmlFor="vendorEmailId">
                                                    Upload File
                                                </label>
                                                <input
                                                    className="form-control"
                                                    id="vendorEmailId"
                                                    type="file"
                                                    name='file'
                                                    onChange={handleInputChange}
                                                    disabled={pathname.includes("/edit_Validity_job")}
                                                />
                                            </div>
                                        </div>
                                        <div className='d-flex gap-2'>
                                            <button onClick={() => { setData({ ...data, jobsPostedStatus: 'POSTED' }); setIsPostlater(false) }} className="btn-primary-custom" type="submit">
                                            {location.pathname.includes('post_job') ? 'Post Now' : 'Save changes'}
                                        </button>
                                            {location.pathname.includes('post_job') && <button onClick={() => setIsPostlater(true)} className="btn-primary-custom" >
                                                Post Later
                                            </button>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="jc_notes_container p-3 mb-3">
                <p className='jc_notes_head'>Important Notes!</p>

                <div className="line_divide"></div>

                <div className="jc_notes mt-3">
                    <p>AI That Understands Hiring: eBench uses intelligent algorithms to match you with the right candidates—fast, accurately, and with zero guesswork.</p>
                    <p>Vetted Professionals Only: Every candidate is thoroughly assessed for skills, experience, and fit—saving you time and ensuring quality.</p>
                    <p>All-in-One Hiring Platform: Post jobs, manage candidates, schedule interviews, and onboard—all from one intuitive dashboard.</p>
                    <p>Reduce Time & Cost: Cut hiring time by up to 70% and avoid the costs of bad hires with data-backed decision-making.</p>
                    <p>Global Reach, Local Compliance: Find top remote talent while ensuring full compliance with employment laws across regions.</p>
                    <p>Custom Workflows: Tailor the platform for every industry and internal hiring processes—whether you're a startup or a large enterprise.</p>

                </div>
            </div>
            <Modal
                show={postLateerModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                style={{ top: "20%" }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Post Later </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="postDate" className="mb-3">
                            <Form.Label>Select Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={date}
                                onChange={(e) => setDatePl(e.target.value)}
                                min={minDate}
                                max={maxDate}
                            />
                        </Form.Group>
                        <Form.Group controlId="postTime" className="mb-3">
                            <Form.Label>Select Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={time}
                                onChange={(e) => setTime(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className='flex-center' style={{ justifyContent: "center" }}>
                    <Button variant="success" onClick={() => { setIsPostlater(false); submitPostLater() }}>Submit</Button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default RepostJob